import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import img1 from '../../assets/images/carousel-1.jpg';
import img2 from '../../assets/images/carousel-2.jpg';
import img3 from '../../assets/images/carousel-3.jpg';
import img4 from '../../assets/images/carousel-4.jpg';

// position: onde a imagem "ancora" dentro do quadro
// scale: zoom leve pra esconder bordas/marcas d'água indesejadas
const slides = [
    { img: img1, title: 'Ambientes renovados.', position: 'center 25%', scale: 1 },
    { img: img2, title: 'Cores que impressionam.', position: 'center 40%', scale: 1 },
    { img: img3, title: 'Precisão e confiança.', position: 'center 30%', scale: 1.15 },
    { img: img4, title: 'Inovação contínua.', position: 'center 35%', scale: 1 },
];

const HeaderCarousel = () => {
    return (
        <div className="container-fluid p-0 wow fadeIn" data-wow-delay="0.1s">
            <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    {slides.map((slide, i) => (
                        <button
                            key={i}
                            type="button"
                            data-bs-target="#header-carousel"
                            data-bs-slide-to={i}
                            className={i === 0 ? 'active' : ''}
                            aria-current={i === 0 ? 'true' : undefined}
                            aria-label={`Slide ${i + 1}`}
                        >
                            <img className="img-fluid" src={slide.img} alt={`Slide ${i + 1}`} />
                        </button>
                    ))}
                </div>

                <div className="carousel-inner">
                    {slides.map((slide, i) => (
                        <div
                            key={i}
                            className={`carousel-item ${i === 0 ? 'active' : ''}`}
                            style={{
                                height: 'clamp(420px, 70vh, 720px)',
                                position: 'relative',
                                overflow: 'hidden',
                            }}
                        >
                            <img
                                className="w-100 h-100"
                                style={{
                                    objectFit: 'cover',
                                    objectPosition: slide.position,
                                    transform: `scale(${slide.scale})`,
                                    transformOrigin: 'center',
                                }}
                                src={slide.img}
                                alt={`Slide ${i + 1}`}
                            />
                            {/* Gradiente leve só na base, para não escurecer a foto inteira */}
                            <div
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    background: 'linear-gradient(to top, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.05) 35%, rgba(0,0,0,0) 55%)',
                                    pointerEvents: 'none',
                                }}
                            />
                            <div className="carousel-caption d-flex flex-column align-items-center justify-content-end pb-5 px-3">
                                <h1
                                    className="text-uppercase text-white mb-4 animated zoomIn fw-bold text-center"
                                    style={{ 
                                        fontSize: 'clamp(1.75rem, 4.5vw, 2.8rem)', 
                                        textShadow: '0 2px 8px rgba(0,0,0,0.7)',
                                        wordBreak: 'break-word' 
                                    }}
                                >
                                    {slide.title}
                                </h1>
                                <Link to="/produtos" className="btn btn-primary py-3 px-4">Ver mais</Link>
                            </div>
                        </div>
                    ))}
                </div>

                <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Anterior</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Próximo</span>
                </button>
            </div>
        </div>
    );
}

export default HeaderCarousel;